import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";

import { ImageCreationResponse } from "../types";

export const imageApi = createApi({
  reducerPath: "imageApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    createImage: builder.mutation<ImageCreationResponse, FormData>({
      query: (body) => ({
        url: `/images`,
        method: "POST",
        body,
      }),
    }),
    deleteImage: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/images/${id}`,
        method: "DELETE",
      }),
    }),
    sortImages: builder.mutation<void, {ids: string[]}>({
      query: ({ ids }) => ({
        url: `/images/sorting`,
        method: "POST",
        body: { ids }
      }),
    }),

  }),
});

export const { useCreateImageMutation, useDeleteImageMutation, useSortImagesMutation } = imageApi;
